import { Link } from 'react-router-dom';
import '../style/footer.css';

function Footer() {
  const years = Array.from({ length: 11 }, (_, i) => 2025 - i);
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Navigation</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/countries-visited">Countries Visited</Link></li>
            <li><Link to="/next-destination">Next Destination</Link></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Photos</h3>
          <ul className="years-list">
            {years.map(year => (
              <li key={year}>
                <Link to={`/${year}`}>{year}</Link>
              </li>
            ))}
          </ul>
        </div>
        
        <div className="footer-section">
          <h3>Contact</h3>
          <p>
            <a href="mailto:spangkaerparken@has.dk">spangkaerparken@has.dk</a>
          </p>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} JC World Photos. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;